import { render, staticRenderFns } from "./AddImgJackpot.vue?vue&type=template&id=7947565e"
import script from "./AddImgJackpot.vue?vue&type=script&lang=js"
export * from "./AddImgJackpot.vue?vue&type=script&lang=js"
import style0 from "./AddImgJackpot.vue?vue&type=style&index=0&id=7947565e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports